import { Container } from 'pixi.js';

const MAX_OFFSET = 12;
const DECAY_PER_SEC = 1.6;

export const ZOOM_MIN = 0.5;
export const ZOOM_MAX = 2.5;

/**
 * World container with follow + zoom + trauma screenshake. Offset = trauma² ×
 * max, sampled from smooth sine noise (no strobing). UI lives outside this
 * container and never shakes or scales.
 */
export class CameraContainer extends Container {
  private trauma = 0;
  private time = 0;
  private zoomLevel = 1;

  get zoom(): number {
    return this.zoomLevel;
  }

  set zoom(z: number) {
    // 2-decimal rounding keeps repeated ±0.1 steps from drifting.
    this.zoomLevel = Math.round(Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, z)) * 100) / 100;
  }

  addTrauma(amount: number): void {
    this.trauma = Math.min(1, this.trauma + amount);
  }

  tick(dt: number): void {
    this.time += dt;
    this.trauma = Math.max(0, this.trauma - DECAY_PER_SEC * dt);
  }

  /** Center the view on (targetX, targetY) with zoom and shake applied. */
  follow(targetX: number, targetY: number, viewW: number, viewH: number): void {
    const shake = this.trauma * this.trauma;
    const t = this.time;
    const ox = shake * MAX_OFFSET * (Math.sin(t * 91.7) * 0.6 + Math.sin(t * 47.3) * 0.4);
    const oy = shake * MAX_OFFSET * (Math.sin(t * 83.1 + 2.1) * 0.6 + Math.sin(t * 53.9 + 0.7) * 0.4);
    const z = this.zoomLevel;
    this.scale.set(z);
    this.position.set(
      Math.round(viewW / 2 - targetX * z + ox),
      Math.round(viewH / 2 - targetY * z + oy),
    );
  }
}
